/**
 * Route Constants
 * File to hold constants related to routing.
 * Copied from ecomm-front-end. Copied whole file, but change these as we go.
 */

export const GLOWFORGE_CONFIRMATION = {
  BASE_URI: '/confirmation',
  SHOW_GLOBAL_FOOTER: true,
  USE_MARKETING_NAV: true,
  HIDE_NAV_LINKS: true,
};

export const SUPPORT = {
  BASE_URI: '/support',
  TOPIC_URI: '/support/topic',
  PAGE_TITLE: 'Support Pages',
  SEARCH_URI: '/support/search',
  SEARCH_PLACEHOLDER_TEXT: 'Search for Support Documents',
  SUPPORT_ENTRY_TYPES: [
    'questionAndAnswer',
    'supportEntryInstructions',
    'supportEntryTextAndMedia',
  ],
  SHOW_CART: false,
  SHOW_SEARCH: false,
};

export const SETTINGS = {
  PAGE_TITLE: 'User Settings',
  BASE_URI: '/settings',
};

export const CREATE_ACCOUNT = {
  PAGE_TITLE: 'Create Account',
  BASE_URI: '/create-account',
  USE_MARKETING_NAV: true,
};

export const WARRANTY = {
  PAGE_TITLE: 'Warranty',
  BASE_URI: '/warranty',
  HIDE_NAV_LINKS: true,
};

export const PATENTS = {
  PAGE_TITLE: 'Patents',
  BASE_URI: '/patents',
  HIDE_NAV_LINKS: true,
};

export const TERMS = {
  PAGE_TITLE: 'Terms',
  BASE_URI: '/terms',
  USE_MARKETING_NAV: true,
};

export const REFERRAL_PAYMENT = {
  PAGE_TITLE: 'Referral Payment',
  BASE_URI: '/referral-payment',
};

export const SETTINGS_ACCEPT_INVITE = {
  PAGE_TITLE: 'User Create',
  BASE_URI: '/settings/invite/accept',
  HIDE_NAV_LINKS: true,
  HIDE_USER_SECTION: true,
};

export const MARKETING = {
  BASE_URI: '/m/',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
};

export const SETUP = {
  PAGE_TITLE: 'Glowforge',
  BASE_URI: '/setup',
  HIDE_NAV_LINKS: true,
  HIDE_USER_SECTION: true,
};

export const JOBS = {
  PAGE_TITLE: 'Jobs',
  BASE_URI: '/jobs',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const REVIEWS = {
  PAGE_TITLE: 'Glowforge Reviews',
  BASE_URI: '/reviews',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const CUSTOMER_GALLERY = {
  PAGE_TITLE: 'Customer Gallery',
  BASE_URI: '/discover',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const GLOWFORGE_PRODUCTS_PAGE = {
  PAGE_TITLE: 'Glowforge Products',
  BASE_URI: '/products',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const GLOWFORGE_MATERIALS_PAGE = {
  PAGE_TITLE: 'Materials',
  BASE_URI: '/materials',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true,
  INCLUDE_BUY_BUTTON: true,
};

export const GLOWFORGE_LANDING_PAGE = {
  PAGE_TITLE: 'Glowforge - the 3D laser printer',
  BASE_URI: '/',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const GLOWFORGE_LANDING_PAGE_HOME = {
  ...GLOWFORGE_LANDING_PAGE,
  BASE_URI: '/home',
  INCLUDE_BUY_BUTTON: true,
  CANONICAL_URI: '/',
};

export const GLOWFORGE_LANDING_PAGE_HOME_CDN_TEST = {
  ...GLOWFORGE_LANDING_PAGE,
  BASE_URI: '/home-2',
  INCLUDE_BUY_BUTTON: true,
  CANONICAL_URI: '/',
};

export const PAGE_NOT_FOUND = {
  BASE_URI: '/404',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const COMMON = {
  PAGE_ERRORS: {
    PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    FORBIDDEN: 'FORBIDDEN',
  },
};

export const MANUAL = {
  PAGE_TITLE: 'Manual',
  BASE_URI: '/manual',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const FAQ = {
  BASE_URI: '/faq',
  PAGE_TITLE: 'FAQ',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true,
  INCLUDE_BUY_BUTTON: true,
};
